<template>
  <div
    :id="'role-' + props.userRole"
    class="rounded-md shadow-lg border border-gray-200 bg-white"
    :class="{
      ['department-' + department.nameKey]: true,
    }"
  >
    <div
      class="grid gird-cols-1 mobile:grid-cols-[2fr_3fr] grid-rows-[auto_auto_1fr] m-card gap-x-4 gap-y-4"
    >
      <NuxtPicture
        v-if="role.skin"
        class="hidden mobile:flex row-span-3 object-scale-down object-center m-auto"
        :src="role.skin.src"
        :alt="role.skin.alt || ''"
        sizes="128px"
      />
      <h3
        class="text-slate-900"
      >
        {{ t('jc.role.' + props.userRole + '.label') }}
      </h3>
      <p
        class="text-slate-900"
      >
        {{ t('jc.role.' + props.userRole + '.description') }}
      </p>
      <NuxtLink
        :to="localePath({
          name: role['routeName'] ?? 'index',
        })"
        class="bg-department text-department-contrast text-center rounded
              py-2 px-4 min-w-1/2 mr-auto mb-auto mt-3 font-semibold"
      >
        {{ t('jc.component.roleCard.more.label') }}
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Department, UserRole } from '~/composables/charon'
import { DepartmentData, UserRoleData } from '~/composables/charon'

const { t } = useI18n()
const localePath = useLocalePath()

const props = defineProps<{
  userRole: UserRole
}>()

const role = computed<Record<string, any>>(() => UserRoleData[props.userRole])
const department = computed(() => DepartmentData[role.value['department'] as Department])
</script>

<style scoped lang="postcss">
:deep(img) {
  @apply w-full h-full object-cover
}
</style>
